import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { useMoreLikeThisQuery } from '../../../queries/moreLikeThis'
import { useSameRangeQuery } from '../../../queries/SameRange'
import { usePeopleAlsoViewedQuery } from '../../../queries/PeopleAlsoViewed'
import type { ProductInfoProduct, SearchCriteria } from '../../../types'
import { hasProductDisplayImage } from '../../../utils/getProductDisplayImageUrl'
import type { MoreLikeThisTabValue } from '../tabs/moreLikeThisTabsConfig'

export const useMoreLikeThisQueries = (
  searchCriteria: SearchCriteria,
  product: ProductInfoProduct,
): {
  productsBySection: Record<MoreLikeThisTabValue, ProductInfoProduct[]>
  loading: boolean
} => {
  const isDynamicImagesEnabled = useExperiment('search-use-dynamic-images', {
    fallback: false,
  })
  const getRenderableProducts = (
    products: ProductInfoProduct[],
  ): ProductInfoProduct[] =>
    products.filter(productItem =>
      hasProductDisplayImage(productItem, isDynamicImagesEnabled),
    )
  const moreLikeThis = useMoreLikeThisQuery({
    productId: product.id,
    searchCriteria,
  })
  const sameRange = useSameRangeQuery({
    productId: product.id,
    searchCriteria,
    range: product?.range?.key ?? null,
  })
  const peopleAlsoViewed = usePeopleAlsoViewedQuery({
    product,
  })

  return {
    productsBySection: {
      'more-like-this': getRenderableProducts(moreLikeThis.products),
      'more-from-this-range': getRenderableProducts(sameRange.products),
      'people-also-viewed': getRenderableProducts(peopleAlsoViewed.products),
    },
    loading:
      moreLikeThis.loading || sameRange.loading || peopleAlsoViewed.loading,
  }
}
